var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clockPanel"},[_c('Clock',{attrs:{"time":_vm.time,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }